<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="63.7" height="44.02" viewBox="0 0 63.7 44.02">
        <g id="igr_mhd-liste_icon" transform="translate(-0.13 -2.2)">
            <g id="Gruppe_1" data-name="Gruppe 1">
                <path id="Pfad_1" data-name="Pfad 1" d="M28.01,9.03H62.73V40.16H28.01" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
                <line id="Linie_1" data-name="Linie 1" y2="6.59" transform="translate(49.67 6.02)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
                <line id="Linie_2" data-name="Linie 2" y2="6.59" transform="translate(34.75 6.02)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
                <line id="Linie_3" data-name="Linie 3" x2="37.55" transform="translate(25.18 17.55)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
            </g>
            <g id="Gruppe_2" data-name="Gruppe 2">
                <path id="Pfad_2" data-name="Pfad 2" d="M27.54,39.64c-1.17-7.93-4.98-13.79-9.72-15.41,4.71-1.69,8.51-7.76,9.7-15.52" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
                <path id="Pfad_3" data-name="Pfad 3" d="M2.7,8.49c1.11,8.11,4.96,14.12,9.77,15.77-4.79,1.72-8.63,7.96-9.76,15.91" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
                <rect id="Rechteck_1" data-name="Rechteck 1" width="27.83" height="4.79" rx="2.395" transform="translate(1.23 3.3)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2.2"/>
                <rect id="Rechteck_2" data-name="Rechteck 2" width="27.83" height="4.79" rx="2.395" transform="translate(1.23 40.33)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2.2"/>
            </g>
            <path id="Pfad_4" data-name="Pfad 4" d="M34.75,28.71l5.12,5.11,9.04-9.93" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
        </g>
    </svg>
</template>

<script>
export default {
    props: ['color'],
    name: "mdhIcon"
}
</script>

<style scoped>

</style>
